export enum Seniority {
    STAGIAIRE = 'Stagiaire',
    JUNIOR = 'Junior',
    SENIOR = 'Senior',
    CONFIRME = 'Confirmé',
}

export enum InvoiceStatus {
    PREVISIONNELLE = 'Prévisionnelle',
    A_EDITER = 'À éditer',
    A_VALIDER = 'À valider',
    A_EMETTRE = 'À émettre',
    EMISE = 'Émise',
    PARTIELLEMENT_RECOUVREE = 'Partiellement recouvrée',
    RECOUVREE = 'Recouvrée',
    ANNULEE = 'Annulée'
}

export enum InvoiceType {
    HONORAIRES_ET_FRAIS = 'Honoraires et frais',
    HONORAIRES = 'Honoraires',
    FRAIS = 'Frais'
}
